import { render, staticRenderFns } from "./simpleClass.vue?vue&type=template&id=4aba8cba&scoped=true&"
import script from "./simpleClass.vue?vue&type=script&lang=js&"
export * from "./simpleClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aba8cba",
  null
  
)

export default component.exports